import { translatePage, restoreOriginalText } from '../services/translationService';

/**
 * Utility functions for translation
 */

const isPrerenderCrawler = () => (
  typeof navigator !== 'undefined' &&
  (navigator.webdriver || /HeadlessChrome|Prerender/i.test(navigator.userAgent || ''))
);

/**
 * Translates the entire page when the language changes
 * @param {string} currentLanguage - The current language code
 * @param {string} previousLanguage - The previous language code (optional)
 */
export const translatePageContent = async (currentLanguage, previousLanguage = null) => {
  // Add a small delay to allow the DOM to update
  setTimeout(async () => {
    try {
      if (currentLanguage === 'en') {
        // If switching back to English, restore original text content
        console.log('Switching back to English - restoring original content');
        restoreOriginalText();
      } else {
        await translatePage(currentLanguage);
        console.log(`Page translated to ${currentLanguage}`);
      }
    } catch (error) {
      console.error('Error translating page:', error);
    }
  }, 300);
};

/**
 * Adds the no-translate class to elements that should not be translated
 * This should be called once when the app initializes
 */
export const setupNoTranslateElements = () => {
  // Add no-translate class to elements that should not be translated
  const noTranslateSelectors = [
    'img', // All images
    'svg', // All SVGs
    '.logo', // Elements with class 'logo'
    '[data-no-translate]', // Elements with data-no-translate attribute
    'code', // Code blocks
    'pre', // Preformatted text
    '.no-translate', // Elements already marked with no-translate class
    '[aria-hidden="true"]', // Hidden elements
  ];
  
  // Select all elements matching the selectors
  const elements = document.querySelectorAll(noTranslateSelectors.join(','));
  
  // Add the no-translate class to each element
  elements.forEach(element => {
    if (!element.classList.contains('no-translate')) {
      element.classList.add('no-translate');
    }
  });
  
  console.log('No-translate elements setup complete');
};

/**
 * Initializes the translation system
 * This should be called once when the app initializes
 */
export const initializeTranslation = () => {
  if (isPrerenderCrawler()) {
    return;
  }

  // Set up elements that should not be translated
  setupNoTranslateElements();
  
  // Add a global style to prevent FOUC (Flash of Untranslated Content)
  const style = document.createElement('style');
  style.textContent = `
    .translating {
      opacity: 0.8;
      transition: opacity 0.3s ease;
    }
    
    .no-translate {
      /* Add any specific styles for no-translate elements */
    }
  `;
  document.head.appendChild(style);
};
